const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as { default?: Record<string, string> };

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    // Merge with namespace prefix so keys match t('namespace.key') calls
    if (module.default) {
      const namespaced: Record<string, string> = {};
      Object.entries(module.default).forEach(([key, value]) => {
        namespaced[`${namespace}.${key}`] = value;
      });
      messages[lang].translation = {
        ...messages[lang].translation,
        ...namespaced,
      };
    }
  }
});

export default messages;